// Items are `{ id, label, disabled, … }`; the search is a plain case-insensitive substring
// match on the label, which is what a short, local list needs.
export const filterPickerItems = (items = [], query = '') => {
    const term = String(query || '').trim().toLowerCase();
    const list = Array.isArray(items) ? items.filter(Boolean) : [];
    if (!term) return list;
    return list.filter((item) => String(item.label ?? '').toLowerCase().includes(term));
};
